import React, { useEffect, useMemo, useState } from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import { transformTranslateFromValues, dateTimeToserver, dateTimeToServerIso } from "lib/helpers";
import Modal from "components/Modal";
import { TextArea } from "components/form";
import { CkEditorFull } from "components/form";
import { GalleryField } from "components/form";
import { useCore } from "store/core";
import TextFieldSlug from "components/form/TextFieldSlug";
import MyFormComponent from "utils/DynamicEntityTypeFields";
import extractValues from "utils/extractValues";
import MultiselectAdd from "components/form/MultiSelectAdd";
import CkEditorFullNew from "components/form/CkEditorFullNew";
import MultiselectAddNew from "components/form/MultiSelectAddNew";
import formatTime from "utils/formatTime";
import VideoSelector from "utils/VideoSelector";
import { useList } from "store/list";
import { getSliderName } from "store/core";

export default function Add(props) {
  const [showSelect, setShowSelect] = useState(false);
  const [video, setVideo] = useState(null);
  const core = useCore();
  const { dispatch, clear } = useList();
  const initialValues = useMemo(
    () => ({
      translations: {
        fa: {
          title: "",
          slug: "",
          summary: "",
          content: "",
        },
        en: {
          title: "",
          slug: "",
          summary: "",
          content: "",
        },
      },
      categories: [],
      tags: [],
      keywords: [],
      status: "draft",
      isFeatured: false,
      commentsEnabled: true,
      publishedAt: null,
      media: null,
      slider: false,
      streamSlug: "",
      streamDuration: "",
    }),
    [props.show]
  );

  useEffect(() => {
    dispatch(getSliderName("selectFields=id type"));

    return () => {
      dispatch(clear());
    };
  }, []);

  return (
    <>
      <div className="z-[99999999999999] ">
        <VideoSelector
          title="انتخاب ویدیو"
          show={showSelect}
          setVideo={setVideo}
          close={() => {
            setShowSelect(false);
          }}
        />
      </div>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={initialValues}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            if (values.birthday)
              values.birthday = dateTimeToserver(values.birthday, "YYYY-MM-DD");
            if (values.publishedAt)
              values.publishedAt = dateTimeToServerIso(values.publishedAt);

            const result = extractValues(values, [
              "player",
              "staff",
              "coach",
              "referee",
              "team",
              "league",
              "match",
            ]);

            await props.submit(result);
            resetForm();
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty, setFieldValue, values }) => {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useEffect(() => {
              if (video) {
                setFieldValue("streamSlug", video.fullSlug);
                setFieldValue("streamDuration", formatTime(video.duration));
              }
            }, [video, setFieldValue]);

            return (
              <Form>
                <div className="flex flex-col gap-5">
                  <div className="p-2">
                    <div className="space-y-4">
                      <div className="grid md:grid-cols-2 gap-4">
                        <div className="w-full">
                          <Field
                            label="عنوان:"
                            name="translations.fa.title"
                            slugFieldName="translations.fa.slug"
                            component={TextFieldSlug}
                          />
                        </div>
                        <div>
                          <Field
                            label="نامک:"
                            name="translations.fa.slug"
                            component={TextField}
                          />
                        </div>
                      </div>

                      <div className="w-full">
                        <Field
                          label="خلاصه"
                          name="translations.fa.summary"
                          component={TextArea}
                          className="w-full"
                        />
                      </div>

                      <div>
                        <Field
                          label="توضیحات:"
                          name="translations.fa.content"
                          component={CkEditorFullNew}
                        />
                      </div>
                    </div>
                    <div className="space-y-4 ">
                      <Field
                        label="دسته بندی ها:"
                        name="categories"
                        valueOnly
                        type="News"
                        collection="category"
                        component={MultiselectAdd}
                        options={core.categories || []}
                      />
                      <Field
                        label=" تگ ها:"
                        name="tags"
                        valueOnly
                        type="News"
                        collection="tag"
                        component={MultiselectAdd}
                        options={core.tags || []}
                      />
                      <Field
                        label=" کلمات کلیدی :"
                        name="keywords"
                        valueOnly
                        component={MultiselectAddNew}
                      />
                    </div>
                    <div className="space-y-4 ">
                      <Field
                        label="وضعیت:"
                        name="status"
                        component={Select}
                        options={[
                          { value: "draft", label: "پیش نویس" },
                          { value: "published", label: "منتشر شده" },
                          { value: "archived", label: "بایگانی شده" },
                        ]}
                        className="w-full px-3 py-2 border rounded mt-2"
                      />
                      {values?.status === "published" && (
                        <div className="intro-y col-span-2">
                          <Field
                            label="مشخص کردن وضعیت اسلایدر :"
                            name="slider"
                            valueOnly
                            type="News"
                            collection="slider"
                            component={Select}
                            options={core?.slider || []}
                          />
                        </div>
                      )}

                      <div className="grid md:grid-cols-2 gap-4">
                        <div>
                          <Field
                            label="نمایش ویژه:"
                            name="isFeatured"
                            component={Select}
                            options={[
                              { value: true, label: "بله" },
                              { value: false, label: "خیر" },
                            ]}
                            className="w-full px-3 py-2 border rounded"
                          />
                        </div>
                        <div>
                          <Field
                            label="نظرات فعال باشد:"
                            name="commentsEnabled"
                            component={Select}
                            options={[
                              { value: true, label: "بله" },
                              { value: false, label: "خیر" },
                            ]}
                            className="w-full px-3 py-2 border rounded"
                          />
                        </div>
                        <div>
                          <Field
                            label=" تاریخ انتشار:"
                            name="publishedAt"
                            hasTime
                            component={PersianDataPicker}
                          />
                        </div>
                      </div>
                      <div>
                        <button
                          onClick={() => {
                            setShowSelect(true);
                          }}
                          className="btn btn-primary shadow-md w-full sm:w-56  sm:dark:text-gray-300 md:w-auto"
                          type="button"
                        >
                          انتخاب ویدیو
                        </button>
                      </div>
                      {video && (
                        <div className="mt-3 p-3 bg-green-100 border border-green-400 rounded-lg">
                          <p className="text-green-700 font-semibold text-[13px]">
                            ویدیو انتخاب شده: {video?.title}
                          </p>
                        </div>
                      )}
                      <div className="mt-3">
                        <Field
                          label="مدیا"
                          name="media"
                          dataType="id"
                          component={GalleryField}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer flex text-right gap-3">
                    <button
                      type="button"
                      disabled={isSubmitting}
                      onClick={props.close}
                      className="btn btn-outline-secondary w-20 mr-1"
                    >
                      انصراف
                    </button>
                    <button
                      className="btn btn-primary w-20"
                      type="submit"
                      disabled={!!(isSubmitting || !dirty)}
                    >
                      {isSubmitting ? <Loading /> : "ذخیره"}
                    </button>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
}
